
import { defineComponent } from 'vue';
import utilities from '@/Utilities/common';
import { Picture, PictureSource, SourceType } from '@/models/Muffin/picture';
import { Webp } from "@/models/Muffin/webp";

export default defineComponent({
    props:{
        details: {
            type: Picture,
            default: () => new Picture()
        },
        classImg:{
            type: [Object, String],
            default: () => {}
        },
        classBox:{
            type: [Object, String],
            default: () => {}
        },
        classPic:{
            type: [Object, String],
            default: () => {}
        },
        fetchpriority: {
            type: String,
            default: undefined
        }
    },
    data(){
        let timeout: any = null;
        return {
            loaded: false,
            timeout,
            webpOff: false
        };
    },
    mounted(){
        this.webpOff = Webp.support() ? false : true;
        if(!utilities.cookiebotCheckAll()){
            this.testImgHeight();
        }
    },
    watch:{
        loaded:{
            handler(newLoaded) {
                if(newLoaded && this.timeout){
                    clearTimeout(this.timeout);
                }
            },
            immediate: true
        }
    },
    computed: {
        main():string{
            let best = this.details.bestImg();
            if(best){
                return best;
            }

            if(this.details.main && !(this.webpOff && this.details.main.includes('webp'))){
                return this.details.main;
            }

            if(this.details.sources && this.details.sources.length > 0){
                let sources = this.details.sources.filter(s => s.url.toLowerCase().includes('.jpg') || s.url.toLowerCase().includes('.jpeg') || s.url.toLowerCase().includes('.png'));
                return sources.length > 0 ? sources[0].url : this.details.sources[0].url;
            }
            return '';
        },
        title():string|undefined{
            if(this.details.title){
                return this.details.title;
            }
            let main = this.main;
            let filename = main ? main.split('/').pop() : null;
            if(!filename){
                return undefined;
            }

            return filename.replace(/_|-|\./, ' ');
        },
        classNamesBox(): Object{
            let rst = {'skeleton-box': !this.loaded};
            let clBox: Object = this.classBox instanceof Object ? {...this.classBox,...rst} : rst;
            if(this.classBox && (this.classBox instanceof String || typeof this.classBox == 'string')) {
                let list: Array<string> = this.classBox.split(' ');
                list.forEach((l) => {
                    if(l){
                        clBox = {...clBox,...{[l]:true}};
                    }
                });
            }
            return clBox;
        },
        sources(): Array<SourceType> {
            return this.details?.sourcesTypes() ?? [];
        }
    },
    methods: {
        testImgHeight(){
            let el = this.$el ? this.$el.querySelector('img') : null;
            let height = el ? (el as HTMLImageElement)?.naturalHeight ?? null : null;
            if(height){
                this.loaded = true;
            }else{
                this.timeout = setTimeout(() => this.testImgHeight(), 150);
            }
        },
        srcset(source: PictureSource): string {
            let type = this.type(source);
            return source.condition && source.condition != type ? `${source.url} ${source.condition}` : source.url;
        },
        type(source: PictureSource): string {
            let ext: string|undefined = source.url.split('.').pop();
            if(!ext){
                return 'jpeg';
            }
            switch (ext.toLowerCase()) {
                case 'png':
                case 'webp':
                    return ext.toLowerCase();
                default: 
                    return 'jpeg';
            }
        },
        error(e: any) {
            //this.loaded = true;
            this.$emit('error',e);
        },
        actionClick(e: any){
            this.$emit('click',e);
        },
        imgLoad(e: any){ 
            if(!this.loaded){
                this.loaded = true;
            }
            this.$emit('load',e);
        }
    }
});
